import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {GridToolbarFilterButton} from '@mui/x-data-grid-pro';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Grid from '@mui/material/Grid';

import {faMagnifyingGlass, faXmark} from '@fortawesome/pro-light-svg-icons';

// Taken from example: https://mui.com/components/data-grid/filtering/#quick-filter
function QuickSearchToolbar(props) {
  return (
    <>
      <TextField
        variant="standard"
        value={props.value}
        onChange={props.onChange}
        placeholder="Search…"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                title="Clear"
                aria-label="Clear"
                size="small"
                style={{visibility: props.value ? 'visible' : 'hidden'}}
                onClick={props.clearSearch}
              >
                <FontAwesomeIcon icon={faXmark} />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          width: {
            xs: 1,
            sm: 'auto',
          },
          m: (theme) => theme.spacing(1, 0.5, 1.5),
          '& .MuiSvgIcon-root': {
            mr: 0.5,
          },
          '& .MuiInput-underline:before': {
            borderBottom: 1,
            borderColor: 'divider',
          },
        }}
      />
    </>
  );
}

// A datagrid toolbar with a filter button and quick search filter
export default function CustomToolBar(props) {
  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center" className="p-lr-15">
      <GridToolbarFilterButton
        ref={props.setFilterButtonEl}
        sx={{
          '& .MuiBadge-root .MuiBadge-anchorOriginTopRightRectangular': {
            backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--literacy-orange'),
          },
        }}
      />
      <QuickSearchToolbar value={props.value} onChange={props.onChange} clearSearch={props.clearSearch} />
    </Grid>
  );
}
